import {
  SET_TRATAMIENTO,
  SET_NOMBRE_VTP_NUEVOS,
  SET_APELLIDO_MATERNO_VTP_NUEVOS,
  SET_APELIIDO_PATERNO_VTP_NUEVOS,
  SET_ESTADO_VTP_NUEVOS,
  SET_CIUDAD_VTP_NUEVOS,
  SET_ID_CONCESIONARIO_VTP_NUEVOS,
  SET_CONCESIONARIO_VTP_NUEVOS,
  SET_TELEFONO_VTP_NUEVOS,
  SET_MOVIL_VTP_NUEVOS,
  SET_CORREO_VTP_NUEVOS,
  SET_COMENTARIOS_VTP_NUEVOS,
  SET_SEXO,
  SET_AVISO_PRIVACIDAD_VTP_NUEVOS,
  SET_TERMINOS_Y_CONDICIONES_VTP_NUEVOS,
  SET_TRANSFERENCIA_DE_DATOS_VTP_NUEVOS,
  SET_CONTACO_MARKETING_VTP_NUEVOS,
  SET_VEIHICULO_VTP_NUEVOS,
  SET_TIPO_CITA_VTP_NUEVOS,
  RESET_STATE_VTP_NUEVOS,
} from "../types";

/**
 * Función para reiniciar el state
 * @returns
 */
export function reiniciarStateAction() {
  return async (dispatch) => {
    dispatch({ type: RESET_STATE_VTP_NUEVOS });
  };
}

/**
 *
 * @param {*} inTratamiento
 * @returns
 */
export function setTratamientoAction(inTratamiento) {
  const sexo = inTratamiento === "Sr" ? "Masculino" : "Femenino";

  return (dispatch) => {
    dispatch(setTratamiento(inTratamiento));
    dispatch(setSexo(sexo));
  };
}
const setTratamiento = (inTratamiento) => ({
  type: SET_TRATAMIENTO,
  payload: inTratamiento,
});
const setSexo = (inSexo) => ({
  type: SET_SEXO,
  payload: inSexo,
});

/**
 *
 * @param {*} inNombre
 * @returns
 */
export function setNombreAction(inNombre) {
  return (dispatch) => {
    dispatch(setNombre(inNombre));
  };
}
const setNombre = (inNombre) => ({
  type: SET_NOMBRE_VTP_NUEVOS,
  payload: inNombre,
});

/**
 *
 * @param {*} inApellidoPaterno
 * @returns
 */
export function setApellidoPaternoAction(inApellidoPaterno) {
  return (dispatch) => {
    dispatch(setApellidoPaterno(inApellidoPaterno));
  };
}
const setApellidoPaterno = (inApellidoPaterno) => ({
  type: SET_APELIIDO_PATERNO_VTP_NUEVOS,
  payload: inApellidoPaterno,
});

/**
 *
 * @param {*} inApellidoMaterno
 * @returns
 */
export function setApellidoMaternoAction(inApellidoMaterno) {
  return (dispatch) => {
    dispatch(setApellidoMaterno(inApellidoMaterno));
  };
}
const setApellidoMaterno = (inApellidoMaterno) => ({
  type: SET_APELLIDO_MATERNO_VTP_NUEVOS,
  payload: inApellidoMaterno,
});

/**
 *
 * @param {*} inTelefono
 * @returns
 */
export function setTelefonoAction(inTelefono) {
  return (dispatch) => {
    dispatch(setTelefono(inTelefono));
  };
}
const setTelefono = (inTelefono) => ({
  type: SET_TELEFONO_VTP_NUEVOS,
  payload: inTelefono,
});

/**
 *
 * @param {*} inMovil
 * @returns
 */
export function setMovilAction(inMovil) {
  return (dispatch) => {
    dispatch(setMovil(inMovil));
  };
}
const setMovil = (inMovil) => ({
  type: SET_MOVIL_VTP_NUEVOS,
  payload: inMovil,
});

/**
 *
 * @param {*} inCorreo
 * @returns
 */
export function setCorreoAction(inCorreo) {
  return (dispatch) => {
    dispatch(setCorreo(inCorreo));
  };
}
const setCorreo = (inCorreo) => ({
  type: SET_CORREO_VTP_NUEVOS,
  payload: inCorreo,
});

/**
 *
 * @param {*} inEstado
 * @returns
 */
export function setEstadoAction(inEstado) {
  return (dispatch) => {
    dispatch(setEstado(inEstado));
  };
}
const setEstado = (inEstado) => ({
  type: SET_ESTADO_VTP_NUEVOS,
  payload: inEstado,
});

/**
 *
 * @param {*} inCiudad
 * @returns
 */
export function setCiudadAction(inCiudad) {
  return (dispatch) => {
    dispatch(setCiudad(inCiudad));
  };
}
const setCiudad = (inCiudad) => ({
  type: SET_CIUDAD_VTP_NUEVOS,
  payload: inCiudad,
});

/**
 *
 * @param {*} inIdConcesionario
 * @returns
 */
export function setIdConcesionarioAction(inIdConcesionario) {
  return (dispatch) => {
    dispatch(setIdConcesionario(inIdConcesionario));
  };
}
const setIdConcesionario = (inIdConcesionario) => ({
  type: SET_ID_CONCESIONARIO_VTP_NUEVOS,
  payload: inIdConcesionario,
});

/**
 *
 * @param {*} inConcesionario
 * @returns
 */
export function setConcesionarioAction(inConcesionario) {
  return (dispatch) => {
    dispatch(setConcesionario(inConcesionario));
  };
}
const setConcesionario = (inConcesionario) => ({
  type: SET_CONCESIONARIO_VTP_NUEVOS,
  payload: inConcesionario,
});

/**
 *
 * @param {*} inComentarios
 * @returns
 */
export function setComentariosAction(inComentarios) {
  return (dispatch) => {
    dispatch(setComentarios(inComentarios));
  };
}
const setComentarios = (inComentarios) => ({
  type: SET_COMENTARIOS_VTP_NUEVOS,
  payload: inComentarios,
});

/**
 *
 * @param {*} inAvisosDePrivacidad
 * @returns
 */
export function setAvisosDePrivacidadAction(inAvisosDePrivacidad) {
  return (dispatch) => {
    dispatch(setAvisosDePrivacidad(inAvisosDePrivacidad));
  };
}
const setAvisosDePrivacidad = (inAvisosDePrivacidad) => ({
  type: SET_AVISO_PRIVACIDAD_VTP_NUEVOS,
  payload: inAvisosDePrivacidad,
});

/**
 *
 * @param {*} inTerminosCondiciones
 * @returns
 */
export function setTerminosCondicionesAction(inTerminosCondiciones) {
  return (dispatch) => {
    dispatch(setTerminosCondiciones(inTerminosCondiciones));
  };
}
const setTerminosCondiciones = (inTerminosCondiciones) => ({
  type: SET_TERMINOS_Y_CONDICIONES_VTP_NUEVOS,
  payload: inTerminosCondiciones,
});

/**
 *
 * @param {*} inTransferenciaDatos
 * @returns
 */
export function setTransferenciaDeDatosAction(inTransferenciaDatos) {
  return (dispatch) => {
    dispatch(setTransferenciaDeDatos(inTransferenciaDatos));
  };
}
const setTransferenciaDeDatos = (inTransferenciaDatos) => ({
  type: SET_TRANSFERENCIA_DE_DATOS_VTP_NUEVOS,
  payload: inTransferenciaDatos,
});

/**
 *
 * @param {*} inContactoMarketing
 * @returns
 */
export function setContactoMarketingAction(inContactoMarketing) {
  return (dispatch) => {
    dispatch(setContactoMarketing(inContactoMarketing));
  };
}
const setContactoMarketing = (inContactoMarketing) => ({
  type: SET_CONTACO_MARKETING_VTP_NUEVOS,
  payload: inContactoMarketing,
});

/**
 *
 * @param {*} inVehiculo
 * @returns
 */
export function setVehiculoAction(inVehiculo) {
  return (dispatch) => {
    dispatch(setVehiculo(inVehiculo));
  };
}
const setVehiculo = (inVehiculo) => ({
  type: SET_VEIHICULO_VTP_NUEVOS,
  payload: inVehiculo,
});

/**
 *
 * @param {*} inTipoCita
 * @returns
 */
export function setTipoCitaAction(inTipoCita) {
  return (dispatch) => {
    dispatch(setTipoCita(inTipoCita));
  };
}
const setTipoCita = (inTipoCita) => ({
  type: SET_TIPO_CITA_VTP_NUEVOS,
  payload: inTipoCita,
});
